// extracted by mini-css-extract-plugin
export default {"recos":"q5-z","productCardOverride":"r5-z","rowHasBadge":"s5-z"};